import api from './Api'

const route = '/movements'
const stats = '/stats/movement'

export default {
  get: params => api().get(`${route}`, { params: { ...params, expand: 'vehicle,vehicle.dealer,sourceLocation,destinationLocation,responsible,driver' } }),
  view: params => {
    // Expand por defecto incluye equipment_status
    const defaultExpand = 'vehicle,vehicle.dealer,sourceLocation,destinationLocation,responsible,driver,responsibleEntrega,equipment_status,destinationDealer'
    const expand = params.expand ? `${defaultExpand},${params.expand}` : defaultExpand
    return api().get(`${route}/${params.id}`, { params: { ...params, expand } })
  },
  post: (payload, params) => api().post(`${route}`, payload),
  put: (payload, params) => api().put(`${route}/${payload.id}`, payload),
  addImages: (id, payload) => api().post(`${route}/${id}/images`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  addAdditionalImages: (id, payload) => api().post(`${route}/${id}/images/additional`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  removeAdditionalImage: (movementId, imageId) => api().delete(`${route}/${movementId}/images/additional/${imageId}`),
  addAdditionalDocs: (id, payload) => api().post(`${route}/${id}/docs/additional`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  removeAdditionalDoc: (movementId, docId) => api().delete(`${route}/${movementId}/docs/additional/${docId}`),
  addDamageDocs: (id, payload) => api().post(`${route}/${id}/docs/damage`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  removeDamageDoc: (movementId, docId) => api().delete(`${route}/${movementId}/docs/damage/${docId}`),
  customerSignature: (id, payload) => api().post(`${route}/${id}/images/customer`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  customerSignatureReturn: (id, payload) => api().post(`${route}/${id}/images/customer`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  uploadSecondDriverData: (id, payload) => api().post(`${route}/${id}/images/second-driver`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  scanPlateNumber: (payload) => api().post(`${route}/scan/plate`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  scanVin: (payload) => api().post(`${route}/scan/vin`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data' // Indicar que es FormData
    }
  }),
  // Nuevo método para POST /movement/{id}/set-equipments
  setEquipments: (id, payload) => api().post(`${route}/${id}/set-equipments`, payload),
  aceptarMovimiento: (id) => api().post(`${route}/${id}/accept`),
  changeStatus: (id, payload) => api().put(`${route}/${payload.id}`, payload),
  comodato: id => api().get(`${route}/${id}/comodato`, {
    responseType: 'blob',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/pdf'
    }
  }),
  delete: payload => api().delete(`${route}/${payload}`),
  updateValidationCheckbox: (id, value) => api().patch(`${route}/${id}/toggle-validation-checkbox`, { validation_checkbox: value }),
  getStats: (params = {}) => api().get(`${stats}`, { params })
}
